import { OnInit, TemplateRef, ViewContainerRef, } from '@angular/core';
import { AuthService } from '../core';
import { take } from 'rxjs/operators';
var UserGroupDirective = /** @class */ (function () {
    function UserGroupDirective(templateRef, authService, viewContainer) {
        this.templateRef = templateRef;
        this.authService = authService;
        this.viewContainer = viewContainer;
    }
    UserGroupDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.authService.userGroup$.pipe(take(1)).subscribe(function (userGroup) {
            if (userGroup === _this.condition) {
                _this.viewContainer.createEmbeddedView(_this.templateRef);
            }
            else {
                _this.viewContainer.clear();
            }
        });
    };
    Object.defineProperty(UserGroupDirective.prototype, "solisUserGroup", {
        set: function (condition) {
            this.condition = condition;
        },
        enumerable: true,
        configurable: true
    });
    return UserGroupDirective;
}());
export { UserGroupDirective };
